import React from "react";
import { Form, Input, Button } from "antd";
import { $t } from "~/i18n.js";
import { ExtrasForm } from "~/components/form/extras.jsx";

export default function StepDetails({
  product,
  checkoutItem,
  setCheckoutItem,
  onNext,
  onPrev,
}) {
  
  
  const [form] = Form.useForm();
  React.useEffect(() => {
    form.setFieldsValue(checkoutItem);
  }, [checkoutItem, form]);
  const handleFinish = () => {
    onNext && onNext();
  };
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={checkoutItem}
        onValuesChange={(changed, all) =>
          setCheckoutItem({ ...checkoutItem, ...all })
        }
        requiredMark={false}
        onFinish={handleFinish}
      >
        <Form.Item
          label={$t("Naam")}
          name="name"
          rules={[{ required: true, message: $t("Vul je naam in") }]}
        >
          <Input autoComplete="name" />
        </Form.Item>
        <Form.Item
          label={$t("Email")}
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: $t("Vul een geldig e-mailadres in"),
            },
          ]}
        >
          <Input autoComplete="email" />
        </Form.Item>
        <Form.Item
          label={$t("Telefoonnummer")}
          name="phone"
          rules={[{ required: true, message: $t("Vul je telefoonnummer in") }]}
        >
          <Input autoComplete="tel" />
        </Form.Item>

        <ExtrasForm extras={product?.extras || []} />

        <Form.Item label={$t("Opmerking")} name="remark" rules={[]}>
          <Input.TextArea rows={2} />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 24,
          }}
        >
          <Button onClick={onPrev}>{$t("Terug")}</Button>
          <Button type="primary" htmlType="submit">
            {$t("Volgende")}
          </Button>
        </div>
      </Form>
    </>
  );
}
